import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { downloadFile, sleep } from '@/utils/helper';
import { $file, $http } from '@/axios';
import store from '@/store';
import router from '@/plugins/router';

// 查询零件列表
export const queryDigitalMeshes: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDigitalMeshes', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/v1/asset/component/pagelist', payload);
    commit('setDigitalMeshes', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setDigitalMeshes', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询零件详情
export const queryDigitalMeshDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setDigitalMeshDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/asset/component/${payload}/detail`);
    commit('setDigitalMeshDetail', { data: res, loading: false });
  } catch (e) {
    commit('setDigitalMeshDetail', { data: null, loading: false });
  }
};

// 查询零件类型列表
export const queryComponentTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setComponentTypes', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/ComponentType');
    commit('setComponentTypes', { data: res });
  } catch (e) {
    commit('setComponentTypes', { data: [] });
  }
};

// 查询光源轴向类型列表
export const queryAxialTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setAxialTypes', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/AxialType');
    commit('setAxialTypes', { data: res });
  } catch (e) {
    commit('setAxialTypes', { data: [] });
  }
};

// 查询光源摆放类型列表
export const queryIlluminantTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setIlluminantTypes', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/IlluminantType');
    commit('setIlluminantTypes', { data: res });
  } catch (e) {
    commit('setIlluminantTypes', { data: [] });
  }
};

// 添加零件
export const addDigitalMesh: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    const code: string = await $http.get('/data/gencode');
    await $http.post('/v1/asset/component/add', { ...payload, code });
    store.commit('common/setToast', { visible: true, text: '保存成功，即将返回列表页' });
    await sleep(1);
    const routeQuery: any = { tab: 1, pageNum: 1, pageSize: 10, brandId: payload.brandId };
    await router.push({ name: 'digital-mesh', query: routeQuery });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑零件
export const editDigitalMesh: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/component/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除零件
export const deleteDigitalMesh: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/component/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 上下架零件
export const shelfDigitalMesh: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/component/publish', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 批量刷新索引
export const refreshDigitalMeshIndex: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/batch/refresh', payload);
    await $http.post('/v1/asset/item/refresh', payload);
    store.commit('common/setToast', { visible: true, text: '索引刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 更新零件缩略图
export const updateDigitalMeshThumb: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDigitalMeshThumb', { ...state.thumb, loading: true });
    const res = await $http.post('/v1/asset/component/modifyimg', payload);
    commit('setDigitalMeshThumb', { data: res, loading: false });
  } catch (e) {
    commit('setDigitalMeshThumb', { data: null, loading: false });
  }
};

// 调整零件颜色信息
export const updateDigitalMeshColor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  await $http.post('/v1/asset/component/modifycolor', payload);
  store.commit('common/setToast', { visible: true, text: '颜色保存成功' });
};

// 新增价格
export const addDigitalMeshPrice: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setPriceDialog', { ...state.priceDialog, loading: true });
    await $http.post('/item/business/model/add', payload);
  } finally {
    commit('setPriceDialog', { visible: false, loading: true });
  }
};

// 编辑价格
export const editDigitalMeshPrice: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setPriceDialog', { ...state.priceDialog, loading: true });
    await $http.post('/item/business/model/modify', payload);
  } finally {
    commit('setPriceDialog', { visible: false, loading: true });
  }
};

// 导出零件价格
export const exportDigitalMeshPrice: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setModalLoading', true);
    const res: { blob: Blob; filename: string } = await $file.post('/v1/data/asset/component/export', payload);
    downloadFile(res.blob, '零件价格列表');
  } finally {
    commit('setModalLoading', false);
  }
};

// 删除零件过滤项配置
export const deleteDigitalMeshFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/component/filterdelete', payload);
    return true;
  } catch (e) {
    return false;
  }
};

// 保存零件过滤项配置
export const saveDigitalMeshFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/component/filterbatchmodify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } catch (e) {
    return;
  }
};

// 根据路径获取模型信息
export const queryModelByPath: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setModelInfo', { ...state.modelInfo, loading: true });
    const res: any = await $http.post('/v1/baseinfo/ueitem/mesh/getcomponentmesh', payload);
    const ueType = res?.ueType || '';
    if (ueType === 'StaticObj' || ueType === 'DynamicMesh') {
      const detail = await $http.post('v1/ue/mesh/detail', payload);
      commit('setModelInfo', { data: detail, loading: false });
    } else if (ueType === 'VersedecoActor' || ueType === 'StaticMesh') {
      // Actor 不需要插槽和缩放配置，所以不查询详情
      commit('setModelInfo', { data: res, loading: false });
    } else {
      // StaticMesh 不能用来创建零件
      commit('setModelInfo', { data: null, loading: false });
      store.commit('common/setToast', { visible: true, text: '模型类型错误' });
    }
  } catch (e) {
    commit('setModelInfo', { data: null, loading: false });
  }
};

// 根据品牌查询已发布的连接件
export const queryJointPage: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setJointPage', { ...state.jointPage, loading: true });
    const { search, ...rest } = payload;
    const furnitureNavCommandList = [{ componentType: 2 }];
    const keyWordsNvSearchCommandList = [{ keyWords: [search] }];
    const baseParams = { ...rest, furnitureNavCommandList, isPublish: true };
    const params = search ? { ...baseParams, keyWordsNvSearchCommandList } : baseParams;
    const res: IPageData = await $http.post('/v1/asset/component/search', params);
    const { list: data, pageNum, pageSize, total } = res;
    commit('setJointPage', { data, pageNum, pageSize, total });
  } catch (e) {
    commit('setJointPage', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 根据品牌查询插槽可用的定制材料
export const querySlotMaterials: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSlotMaterials', { ...state.slotMaterials, loading: true });
    const res = await $http.post('/v1/client/asset/component/slotmaterials', payload);
    commit('setSlotMaterials', { data: res });
  } catch (e) {
    commit('setSlotMaterials', { data: [] });
  }
};


